import React, { useContext } from 'react';
import { ThemeContext } from 'Context/ThemeContext';
import { useTranslation } from 'react-i18next';

function RedirectToWhatsapp({ message }) {
  const { theme } = useContext(ThemeContext);
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const msg = tPopup('Need help on {{name}} Android POS. {{message}}', { name: theme?.variable?.name, message });

  const redirectWhatsApp = () => {
    const url = `https://api.whatsapp.com/send?phone=${theme?.variable?.phone}&text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  };
  return (
    <span style={{ color: '#343f98', cursor: 'pointer' }} onClick={redirectWhatsApp}>
      {tCommon('Contact Support')}
    </span>
  );
}

export default RedirectToWhatsapp;
